import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("dwc-cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("dwc-cart", JSON.stringify(items));
    } catch { /* ignore */ }
  }, [items]);

  const add = (product, qty = 1) =>
    setItems((prev) => {
      const found = prev.find((i) => i.id === product.id);
      if (found) return prev.map((i) => (i.id === product.id ? { ...i, qty: Math.min(i.qty + qty, 20) } : i));
      return [...prev, { id: product.id, slug: product.slug, name: product.name, price: product.price, image: (product.images || [])[0] || "", qty }];
    });

  const setQty = (id, qty) =>
    setItems((prev) => (qty < 1 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty: Math.min(qty, 20) } : i))));

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  useEffect(() => {
    if (localStorage.getItem("dwc-featured-added")) return;
    if (items.length > 0) {
      localStorage.setItem("dwc-featured-added", "1");
      return;
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/store/featured`)
      .then((r) => r.json())
      .then(({ product: p }) => {
        if (p) {
          localStorage.setItem("dwc-featured-added", "1");
          setItems([{ id: p.id, slug: p.slug, name: p.name, price: p.price, image: (p.images || [])[0] || "", qty: 1 }]);
        }
      })
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { count, subtotal } = useMemo(
    () => ({
      count: items.reduce((s, i) => s + i.qty, 0),
      subtotal: items.reduce((s, i) => s + i.price * i.qty, 0),
    }),
    [items]
  );

  return <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal }}>{children}</CartContext.Provider>;
};
